import React from 'react';

const About = ({ user }) => {
  return (
    <div style={{ padding: '24px', maxWidth: '900px', margin: '0 auto', textAlign: 'left' }}>
      <h1 style={{ marginBottom: '12px' }}>About Red Handed</h1>
      <p style={{ color: '#aaa', marginTop: 0 }}>Community Intelligence for Video Evidence</p>

      <section style={{ marginTop: '24px' }}>
        <p>
          Red Handed helps communities surface the truth hidden in videos. Upload footage, organize casefiles,
          and analyze frames to uncover key details like vehicles, timelines, and objects of interest.
        </p>
        <p>
          The platform blends collaborative casefile building with AI-powered analysis, making it easy to
          review evidence, share with the public, and coordinate efforts ethically and transparently.
        </p>
      </section>

      <section style={{ marginTop: '24px' }}>
        <h2 style={{ fontSize: '1.25rem', marginBottom: '8px' }}>What you can do</h2>
        <ul style={{ lineHeight: 1.8 }}>
          <li>Create and publish public casefiles</li>
          <li>Browse public evidence and analysis results</li>
          <li>Run AI-assisted frame extraction and summaries</li>
          <li>Collaborate through bounties and community tools</li>
        </ul>
      </section>

      <section style={{ marginTop: '24px' }}>
        <h2 style={{ fontSize: '1.25rem', marginBottom: '8px' }}>Values</h2>
        <ul style={{ lineHeight: 1.8 }}>
          <li>Privacy-respectful evidence handling</li>
          <li>Transparent processes and provenance</li>
          <li>Community-first collaboration</li>
        </ul>
      </section>

      {user && (
        <section style={{ marginTop: '24px', padding: '12px', border: '1px solid #333', borderRadius: '8px' }}>
          <p style={{ margin: 0 }}>
            Signed in as <strong>{user.email || 'User'}</strong>. Head to the Dashboard to manage your casefiles.
          </p>
        </section>
      )}
    </div>
  );
};

export default About;


